import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

// import { ISerialNumber } from '../serialnumber.model';
import { LocaleLevelFilter } from './locallevelfilter.model';
import { Observable } from 'rxjs';
import { IProductLine } from 'src/app/configuration/product/lines/productlines.model';
import { IArea } from 'src/app/models/area.model';
import { ICountry } from 'src/app/models/country.model';
import { ApiHttpService } from 'src/app/services/api-http.service';
import { IAlgorithm } from 'src/app/models/algorithm.model';
import { IIndicator } from 'src/app/models/indicator.model';

import { IRole } from 'src/app/configuration/acl/roles/role.model';
import { IDashboardCustomer } from './filter.model';

export interface IUser {
    id: number;
    loginId: string;
    firstName: string;
    lastName: string;
    emailId: string;
    country: string;
    active: boolean;
    worldwide: boolean;
    areas: IArea[];
    countries: Array<ICountry>;
    roles: IRole[];
    areasForGrid: string;
    countriesForGrid: string;
    rolesForGrid: string;
}

@Injectable()
export class FilterService {
    private _filterUrl = 'common';
    private _userAreaCountries = this._filterUrl + '/user_area_countries'
    private _areasUrl = this._filterUrl + '/areas';
    private _countryUrl = this._filterUrl + '/countries';
    private _localLevels = this._filterUrl + '/country_local_levels';
    private _localLevel2sUrl = this._filterUrl + '/locallevel2s';
    private _customersUrl = this._filterUrl + '/customer_search';
    private _productLinesUrl = '/dashboard/productlines';
    private _serialNumbersUrl = this._filterUrl + '/sn_search';
    private _modelsUrl = this._filterUrl + '/models';
    private _algorithms = '/dashboard/algorithm_pl_indicators';
    public _dashboardAllData = '/dashboard/all_data';
    public _postUrl = '/dashboard/notification_history';
    private _akcPostUrl = `/dashboard/notification_history/acknowledgement/`;
    private _postNotificationCounts = `/dashboard/notification_counts`;
    public _serviceContractUrl = 'servicecontracts';
    private _flaggedChart = '/dashboard/algorithmflagged_chart';
    private _algorithmsChart = '/dashboard/algorithmsn_chart';
    private _exportAllUrl = '/dashboard/export_all/csv';
    public _usersUrl = 'users';

    constructor(private _http: ApiHttpService) {
    }

    getUserAreaCountries(): Observable<any[]> {
        return this._http.get(this._userAreaCountries);
    }

    getCountries(): Observable<ICountry[]> {
        return this._http.get(this._countryUrl);
    }

    getAreas(): Observable<IArea[]> {
        return this._http.get(this._areasUrl);
    }
    // getLocalLevels(filter: LocaleLevelFilter): Observable<any> {
    getLocalLevels(): Observable<any> {
        // return this._http.post(this._localLevels, filter, null, false);
        return this._http.get(this._localLevels);
    }

    getLocalLevel2s(filter: LocaleLevelFilter): Observable<any> {
        return this._http.post(this._localLevel2sUrl, filter, null, true);
    }

    getCustomers(filter: string): Observable<IDashboardCustomer[]> {
        return this._http.get(this._customersUrl + '?customerNumNameSearchStr=' + filter);
    }

    getProductLines(): Observable<IProductLine[]> {
        return this._http.get(this._productLinesUrl);
    }

    getSerialNumbers(filter: string, code: string): Observable<any[]> {
        if(!code || code===null){
            return this._http.get(this._serialNumbersUrl + '?snSearchStr=' + filter);
        }
        return this._http.get(this._serialNumbersUrl + '?snSearchStr=' + filter + '&pl=' + code);
    }

    getModels(): Observable<IAlgorithm[]> {
        return this._http.get(this._modelsUrl);
    }

    getAlgPLIndicators(): Observable<IIndicator[]> {
        return this._http.get(this._algorithms);
    }

    setDashboardData(data:any): Observable<Response> {
        return this._http.post(this._dashboardAllData, data, null, true);
    }

    getExportAllFile(data: any): Observable<HttpResponse<Blob>> {
      return this._http.post<HttpResponse<Blob>>(this._exportAllUrl, data, null, true, '', 'blob');
    }

    setFiltersData(data:any): Observable<Response> {
        return this._http.post(this._postUrl, data, null, true);
    }

    setNotificationHistory(data:any): Observable<Response> {
        return this._http.post(this._postUrl, data, null, true);
    }

    setNotificationCounts(data:any): Observable<Response> {
        return this._http.post(this._postNotificationCounts, data, null, true);
    }

    setAkc(data:any, id:any): Observable<Response> {
        return this._http.put(this._akcPostUrl + id, data);
    }

    setFlaggedChart(data:any): Observable<Response> {
        return this._http.post(this._flaggedChart, data, null, true);
    }

    setAlgorithmsChart(data:any): Observable<Response> {
        return this._http.post(this._algorithmsChart, data, null, true);
    }

    getUser(id: string): Observable<IUser> {
        return this._http.get(this._usersUrl+ `/${id}`);
    }


}
